import {
   CalendarDaysIcon,
   ChatBubbleLeftRightIcon,
   InformationCircleIcon,
   PencilSquareIcon,
   UserCircleIcon,
   VideoCameraIcon,
} from '@heroicons/vue/24/outline';
export const ClientMenuItems = [
   {
      name: 'chatRoom',
      to: { name: 'client-chat' },
      icon: ChatBubbleLeftRightIcon,
      showBadge: true,
   },
   {
      name: 'manageSessions',
      to: { name: 'client-booking' },
      icon: PencilSquareIcon,
   },
   {
      name: 'videoCallRoom',
      icon: VideoCameraIcon,
      to: { name: 'client-session' },
   },
   {
      name: 'journal',
      icon: CalendarDaysIcon,
      to: { name: 'client-journal' },
   },
   {
      name: 'contactAdmin',
      icon: InformationCircleIcon,
      to: { name: 'client-contact-admin' },
   },
];
